import { render, staticRenderFns } from "./AdvertisementDetailsDrawer.vue?vue&type=template&id=b725e522&scoped=true"
import script from "./AdvertisementDetailsDrawer.vue?vue&type=script&lang=js"
export * from "./AdvertisementDetailsDrawer.vue?vue&type=script&lang=js"
import style0 from "./AdvertisementDetailsDrawer.vue?vue&type=style&index=0&id=b725e522&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b725e522",
  null
  
)

export default component.exports